/* global translations */
import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import ImageSvg from './ImageSvg';

const ImagesBlockItemMenu = (props) => {
  const {
    menuType,
    filename,
    memberId,
    fileId,
    profile,
  } = props;

  if (!menuType) {
    return null;
  }

  //
  let menuItems = [];

  if (menuType === 'myImages') {
    menuItems = ['profile', 'delete', 'center'];
  }

  if (menuType === 'adminMemberImages') {
    menuItems = ['profile', 'delete', 'regenerate', 'center'];
  }

  const imageMenuItems = [];

  //
  if (menuItems.indexOf('profile') !== -1) {
    imageMenuItems.push([
      <a
        key="menu_profile"
        href={`/images/thumb_center/${filename}/${memberId}/1`}
        className="btn btn--b btn--smallOneIcon tooltip crop-image"
        data-tooltip={get(translations, 'txt: Profila foto', 'txt: Profila foto')}
        data-filename={filename}
      >
        <span className="btn-static">
          <span className="vcenter">
            <span className="vcenter-inner">
              <ImageSvg svg="icon-profile-4" iconClass="icon--profile-4--small" />
            </span>
          </span>
        </span>
      </a>,
    ]);
    imageMenuItems.push(<span key="menu_profile_ws">&nbsp;</span>);
  }

  //
  if (menuItems.indexOf('delete') !== -1) {
    let deleteHref = `/images/delete/${filename}/${memberId}`;
    if (menuType === 'adminMemberImages') {
      deleteHref = `/images/adminDelete/${filename}/${memberId}/${fileId}`;
    }
    if (profile) {
      deleteHref = '#';
    }
    imageMenuItems.push([
      <a
        key="menu_delete"
        href={deleteHref}
        className={`btn btn--b btn--smallOneIcon tooltip ${profile ? 'delete-profile-image' : 'delete-image'}`}
        data-tooltip={get(translations, 'txt: Dzēst', 'txt: Dzēst')}
      >
        <span className="btn-static">
          <span className="vcenter">
            <span className="vcenter-inner">
              <ImageSvg svg="icon-trash" iconClass="icon--trash" />
            </span>
          </span>
        </span>
      </a>,
    ]);
    imageMenuItems.push(<span key="menu_delete_ws">&nbsp;</span>);
  }

  //
  if (menuItems.indexOf('regenerate') !== -1) {
    imageMenuItems.push([
      <a
        key="menu_regenerate"
        href={`/images/regenerate_sizes/${filename}/${memberId}`}
        className="btn btn--b btn--smallOneIcon tooltip regenerate-image-sizes"
        data-tooltip={get(translations, 'txt: Pārģenerēt trūstošos izmērus', 'txt: Pārģenerēt trūstošos izmērus')}
      >
        <span className="btn-static">
          <span className="vcenter">
            <span className="vcenter-inner">
              <ImageSvg svg="icon-reload" iconClass="icon--reloadSmall" />
            </span>
          </span>
        </span>
      </a>,
    ]);
    imageMenuItems.push(<span key="menu_regenerate_ws">&nbsp;</span>);
  }

  //
  if (menuItems.indexOf('center') !== -1) {
    imageMenuItems.push([
      <a
        key="menu_center"
        href={`/images/thumb_center/${filename}/${memberId}`}
        className="btn btn--b btn--smallOneIcon tooltip crop-image"
        data-tooltip={get(translations, 'txt: Iecentrēt sīktēlu', 'txt: Iecentrēt sīktēlu')}
        data-filename={filename}
      >
        <span className="btn-static">
          <span className="vcenter">
            <span className="vcenter-inner">
              <ImageSvg svg="icon-photos" iconClass="icon--photos" />
            </span>
          </span>
        </span>
      </a>,
    ]);
  }

  return (
    <div className="imagesThumb-image-menu">
      {imageMenuItems}
    </div>
  );
};

ImagesBlockItemMenu.propTypes = {
  menuType: PropTypes.string,
  filename: PropTypes.string,
  fileId: PropTypes.string,
  memberId: PropTypes.string,
  profile: PropTypes.bool,
};

ImagesBlockItemMenu.defaultProps = {
  menuType: '',
  filename: '',
  fileId: '',
  memberId: '',
  profile: false,
};

export default ImagesBlockItemMenu;
